const Logo = (props) => (
  <img
    className="logo"
    alt="Logo"
    src="/static/logo.svg"
    {...props}
  />
);

export default Logo;
